<div class="flex flex-col h-full bg-white overflow-hidden">
  <!-- Bar Haute : retour + ce qu'on édite -->
  <div class="border-t border-b border-gris-3 flex items-center gap-5 p-5 h-[88px] shrink-0">
    <button type="button" (click)="goBack()"
      class="shrink-0 border border-gris-3 rounded-[5px] h-[58px] px-5 flex items-center gap-[10px] fg-noir-2 text-[16px] font-medium cursor-pointer hover:bg-gris-4 transition-colors">
      <app-svg class="fg-gris-1 shrink-0" height="20" svgPath="assets/svg/arrow-back.svg" width="20" />
      {{ 'common.back' | translate }}
    </button>

    @if (activeSectionData(); as section) {
    <div class="flex-1 flex flex-col items-center text-center min-w-0">
      <span class="fg-noir-2 text-[18px] font-semibold leading-none">
        {{ 'admin_settings.title' | translate }} - {{ section.titleKey | translate }}
      </span>
      <span class="fg-gris-1 text-[14px] leading-[20px] mt-1 truncate">
        {{ section.descriptionKey | translate }}
      </span>
    </div>
    }

    <div class="w-[130px] shrink-0"></div>
  </div>

  <!-- Corps : navigation gauche + bloc d'édition -->
  <div class="flex-1 flex overflow-hidden">
    <!-- Navigation des fonctionnalités -->
    <div class="w-[220px] shrink-0 flex flex-col gap-2 overflow-y-auto m-5 mr-0">
      @for (section of sections; track section.key) {
      <button type="button" (click)="selectSection(section.key)"
        class="flex items-center p-3 rounded-[10px] transition-colors border text-left"
        [class.bg-vert-3]="activeSection() === section.key" [class.border-vert-2]="activeSection() === section.key"
        [class.bg-gris-4]="activeSection() !== section.key" [class.border-gris-4]="activeSection() !== section.key">
        <span class="flex-1 text-[14px] fg-noir-2 truncate min-w-0" [class.font-bold]="activeSection() === section.key">
          {{ section.labelKey | translate }}
        </span>
      </button>
      }
    </div>

    <!-- Bloc d'édition de la fonctionnalité choisie -->
    <div class="flex-1 min-w-0 bg-gris-4 rounded-[10px] flex flex-col overflow-hidden m-5">
      <div class="flex-1 overflow-y-auto p-5">
        @switch (activeSection()) {
        @case ('terminal-permissions') {
        <app-terminal-user-permissions />
        }
        @case ('order-modes') {
        <app-terminal-order-modes />
        }
        }
      </div>
    </div>
  </div>
</div>